export const handleActionAbortController = (prevController) => {
  if (prevController) {
    prevController.abort();
  }
  const abortController = new AbortController();
  return abortController;
};
